<template>
  <section>
    <v-menu v-model:opened="menu" location="top">
      <template #activator="{ props }">
        <v-btn
          class="mb-2 bg-primary"
          :disabled="!canDrop && !canHook"
          block
          v-bind="props"
          @click="menu = !menu"
          data-testid="yard-drop-hook-button">
          {{ t('yard.buttons.dropOrHook') }}
          <v-icon>{{ menu ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </template>
      <v-list class="py-4">
        <v-list-item
          @click="$emit('open-detach-dialog')"
          data-testid="yard-drop-hook-drop-button"
          :disabled="!canDrop">
          <v-list-item-title>{{ t('yard.common.terms.drop') }}</v-list-item-title>
          <v-list-item-subtitle>
            {{ t('yard.messages.detachAssetsAtThisSpot') }}
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item
          @click="$emit('open-attach-dialog')"
          data-testid="yard-drop-hook-hook-button"
          :disabled="!canHook">
          <v-list-item-title>{{ t('yard.common.terms.hook') }}</v-list-item-title>
          <v-list-item-subtitle>
            {{ t('yard.messages.attachAssetsFromThisSpot') }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-menu>
  </section>
</template>
<script>
import { defineComponent, ref, computed } from 'vue';
import useYard from '@/modules/yard/composables/useYard';
import { AssetVisitType } from '@nova/core';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewDropHookButton',
  emits: ['open-detach-dialog', 'open-attach-dialog'],
  props: {
    spot: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { t } = useI18n();
    const yardStore = useYard();
    const menu = ref(false);

    const assetVisit = computed(() => props.spot.spotAssignments[0]?.assetVisit);
    const assetContainer = computed(() => props.spot.spotAssignments[0]?.assetContainer);
    const assetVisitContainers = computed(() => assetVisit.value?.assetContainers ?? []);

    const canDrop = computed(
      () =>
        assetVisitContainers.value?.length > 0 &&
        assetVisit.value?.visitType &&
        assetVisit.value.visitType !== AssetVisitType.Live
    );

    const canHook = computed(
      () =>
        assetContainer.value?.id &&
        assetVisit.value?.visitType &&
        assetVisit.value?.visitType !== AssetVisitType.Live
    );

    return {
      t,
      menu,
      assetVisit,
      assetVisitContainers,
      canHook,
      canDrop,
      getSpotIcon: yardStore.getSpotIcon,
      getSpotStatus: yardStore.getSpotStatus,
      isSpotClosed: yardStore.isSpotClosed,
      isSpotOpen: yardStore.isSpotOpen
    };
  }
});
</script>
